import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';

interface IActionButtonsProps {
  isSubmitting: boolean;
  handleSubmit: (
    onValid: (data: any) => Promise<void>,
    onInvalid: () => void
  ) => () => void;
  onSubmit: (data: any) => Promise<void>;
  handleInvalid: () => void;
}

const ActionButtons = ({
  isSubmitting,
  handleSubmit,
  onSubmit,
  handleInvalid,
}: IActionButtonsProps) => {
  const history = useHistory();
  return (
    <div className='d-md-block'>
      <Button
        color='outline-dark'
        onClick={() => history.push('/dashboard')}
        disabled={isSubmitting}
      >
        Cancel
      </Button>
      <Button
        color='primary'
        disabled={isSubmitting}
        onClick={() => {
          handleSubmit(onSubmit, handleInvalid)();
        }}
      >
        {isSubmitting ? `Saving` : `Save`}
      </Button>
    </div>
  );
};

export default ActionButtons;
